import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { EntityQuickFindResponse } from '@erp/rpc';

export function useEntityQuickFind(search: string) {
  const trimmed = search.trim();
  const query = useQuery({
    ...orpc.core.entityQuickFind.search.queryOptions({
      input: trimmed.length > 0 ? { search: trimmed } : skipToken,
    }),
  });

  return {
    ...query,
    results: query.data?.results ?? [],
  } satisfies typeof query & {
    data?: EntityQuickFindResponse;
    results: EntityQuickFindResponse['results'];
  };
}
